import type { CityConfig } from "../city-template/types";

export const silverSpringConfig: CityConfig = {
  city: "Silver Spring",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "silver-spring",
  route: "/silver-spring",
  title: "Emergency Passport Silver Spring, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Silver Spring, Maryland — as fast as 24 hours. Fast passport renewal for Silver Spring, Takoma Park, Wheaton, and Chevy Chase residents. A+ BBB rated courier service near DC.",
  h1: "Emergency & Expedited Passport Services in Silver Spring, MD",
  heroSubtitle: "Silver Spring travelers — from the downtown district to the diverse neighborhoods near DC — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving Montgomery County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Modern%20downtown%20Silver%20Spring%20Maryland%20skyline%20with%20vibrant%20urban%20plaza%2C%20contemporary%20mixed-use%20buildings%2C%20Metro%20station%20entrance%2C%20tree-lined%20streets%2C%20diverse%20multicultural%20neighborhood%2C%20warm%20afternoon%20lighting%2C%20professional%20cityscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20clean%20architectural%20details%2C%20green%20urban%20environment&width=1800&height=700&seq=silver-spring-hero-001&orientation=landscape",
  heroImageAlt: "Modern downtown Silver Spring Maryland skyline with urban plaza and contemporary buildings",
  geoPosition: "38.9907;-77.0261",
  geoPlacename: "Silver Spring, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 25–35 minutes from Silver Spring via I-495 S",
  },
  nearbyCitiesZips: [
    { name: "Silver Spring", zips: "20901, 20902, 20903, 20904, 20905, 20906, 20907, 20910, 20911, 20912, 20914, 20915, 20916, 20918, 20993, 20997" },
    { name: "Takoma Park", zips: "20912, 20913" },
    { name: "Wheaton", zips: "20902, 20906" },
    { name: "Chevy Chase", zips: "20815, 20825" },
    { name: "Bethesda", zips: "20814, 20816, 20817, 20824, 20827" },
    { name: "Rockville", zips: "20847, 20848, 20849, 20850, 20851, 20852, 20853, 20854, 20857" },
    { name: "Kensington", zips: "20891, 20895" },
    { name: "Garrett Park", zips: "20896" },
    { name: "Four Corners", zips: "20901" },
    { name: "Glenmont", zips: "20906" },
    { name: "Aspen Hill", zips: "20906" },
    { name: "Colesville", zips: "20904, 20905" },
    { name: "White Oak", zips: "20901, 20904" },
    { name: "Burtonsville", zips: "20866" },
    { name: "Olney", zips: "20830, 20832, 20833" },
    { name: "Sandy Spring", zips: "20860" },
    { name: "Ashton", zips: "20861" },
    { name: "Brookeville", zips: "20833" },
    { name: "Laytonsville", zips: "20882" },
    { name: "Derwood", zips: "20855" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Silver Spring and DC-metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-subway-line", title: "Metro & DC Corridor", desc: "Serving commuters, diplomats, and federal workers near DC" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Baltimore, MD", route: "/baltimore" },
    { name: "Emergency passport help in Annapolis, MD", route: "/annapolis" },
    { name: "Urgent passport services in Bethesda, MD", route: "/bethesda" },
    { name: "Washington DC passport services", route: "/washington-dc" },
    { name: "Maryland passport services overview", route: "/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Silver Spring, Maryland remotely via secure registered courier. We do not have a walk-in office in Silver Spring — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Silver Spring and Montgomery County travelers without the drive to downtown DC.",
  fpcOfficeAddress: "401 E Pratt St, Baltimore, Maryland 21202",
  fpcOfficeDistance: "Serving Silver Spring, Takoma Park, Wheaton, Chevy Chase, and all of Montgomery County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Montgomery County and the DC corridor. From the bustling downtown of Silver Spring to the multicultural neighborhoods of Takoma Park and Wheaton, from the diplomatic communities of Chevy Chase to the suburban enclaves of Kensington and Garrett Park — we serve all of Silver Spring's diverse communities.",
  nearbyCitiesIntro: "We serve Silver Spring and nearby communities including Takoma Park, Wheaton, Chevy Chase, Bethesda, Rockville, Kensington, Glenmont, Aspen Hill, Colesville, White Oak, Burtonsville, Olney, and all of Montgomery County. We also serve DC residents who prefer our expedited service.",
  howItWorksIntro: "Most Silver Spring travelers complete everything online and ship documents overnight. No need to drive 25–35 minutes to downtown DC or navigate the Beltway during rush hour.",
  mistakesIntro: "Silver Spring is a diverse, international community with significant government, diplomatic, and commuter populations. Here are the most common passport mistakes we see from Silver Spring travelers.",
  testimonialsIntro: "Silver Spring travelers — from federal workers to diplomats to families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Silver Spring, MD? Here are the most common ones we hear from Montgomery County and DC corridor travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for government and diplomatic travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 25–35 min to downtown DC", "Full day commitment — challenging for commuters"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Silver Spring travelers with immediate departure needs — as fast as 24 hours. Perfect for government officials, diplomats, and last-minute international assignments.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Government and diplomatic travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Silver Spring adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Silver Spring address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Silver Spring residents, international students, and new citizens.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Silver Spring residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Silver Spring families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Silver Spring residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Silver Spring MD", description: "Urgent passport processing for Silver Spring Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Silver Spring MD", description: "Fast passport renewal for Silver Spring Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Silver Spring MD", description: "New passport application services for Silver Spring Maryland residents applying for their first passport." },
    { name: "Child Passport Silver Spring MD", description: "Minor passport services for Silver Spring Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "David P.",
      location: "Downtown Silver Spring, MD",
      rating: 5,
      text: "Government assignment to Brussels in 6 days. Fast Passport Center understood the urgency, reviewed my paperwork, and delivered my renewed passport in 48 hours. Their knowledge of federal travel requirements was invaluable.",
      service: "Passport Renewal",
    },
    {
      name: "Maria S.",
      location: "Takoma Park, MD",
      rating: 5,
      text: "Family reunion in Mexico with 10 days notice. Four passports for our family processed in under a week. The agent was bilingual and made the whole process seamless for our multicultural family.",
      service: "Family Passport Bundle",
    },
    {
      name: "Dr. James W.",
      location: "Chevy Chase, MD",
      rating: 5,
      text: "International medical conference in Singapore with 8 days notice. Fast Passport Center had my emergency passport ready in 3 days. No disruption to my research schedule.",
      service: "Emergency Passport",
    },
    {
      name: "Aisha K.",
      location: "Wheaton, MD",
      rating: 5,
      text: "First-time passport for my study abroad program in Morocco. Fast Passport Center handled everything from the acceptance facility appointment to the final delivery. Perfect for international students.",
      service: "First-Time Passport",
    },
  ],
  facilities: [
    {
      id: "silver-spring-1",
      name: "Silver Spring Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8100 Fenton St",
      city: "Silver Spring",
      state: "MD",
      zip: "20910",
      phone: "(301) 588-7730",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Silver Spring, near the Metro station",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Silver Spring and central Montgomery County. Appointments required — book 1–2 weeks in advance. Walkable from the Silver Spring Metro station.",
      icon: "ri-mail-line",
    },
    {
      id: "silver-spring-2",
      name: "Wheaton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11201 Amherst Ave",
      city: "Wheaton",
      state: "MD",
      zip: "20902",
      phone: "(301) 946-0203",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Wheaton, approximately 3 miles west of Silver Spring",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Wheaton and western Silver Spring residents. Accessible via the Wheaton Metro station.",
      icon: "ri-mail-line",
    },
    {
      id: "silver-spring-3",
      name: "Rockville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Research Ct",
      city: "Rockville",
      state: "MD",
      zip: "20850",
      phone: "(301) 279-2000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Rockville, approximately 8 miles northwest of Silver Spring",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Rockville and northern Montgomery County residents. Appointments fill quickly during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "silver-spring-4",
      name: "Montgomery County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "50 Maryland Ave",
      city: "Rockville",
      state: "MD",
      zip: "20850",
      phone: "(240) 777-9460",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Rockville, approximately 8 miles northwest of Silver Spring",
      website: "https://www.montgomerycountymd.gov/",
      websiteLabel: "Montgomery County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Accessible via the Rockville Metro station.",
      icon: "ri-government-line",
    },
    {
      id: "silver-spring-5",
      name: "Bethesda Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6900 Wisconsin Ave",
      city: "Bethesda",
      state: "MD",
      zip: "20814",
      phone: "(301) 657-1000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bethesda, approximately 5 miles west of Silver Spring",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Bethesda and southern Montgomery County residents. Near the Bethesda Metro station. Call ahead to confirm availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25–35 min drive to downtown DC", fpc: "No — ship from Silver Spring" },
    { feature: "Government Travel Support", agency: "No flexibility for federal needs", fpc: "Yes — we understand government timelines" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Silver Spring's busy federal workers and commuters often discover passport needs just weeks before international assignments. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Silver Spring sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Silver Spring and Montgomery County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Silver Spring Post Office appointments fill up fast, especially during summer and government travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Silver Spring residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Silver Spring, Takoma Park, or Wheaton." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near downtown Silver Spring or Rockville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Silver Spring address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Silver Spring, MD?", a: "Fast Passport Center offers emergency passport processing in Silver Spring, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (25–35 minutes from Silver Spring) — without you needing to make the drive or navigate the Beltway during rush hour." },
    { q: "Does Silver Spring have its own passport agency?", a: "No — neither Silver Spring nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 25–35 minutes from Silver Spring via I-495. Fast Passport Center's courier service means Silver Spring residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Takoma Park or Wheaton?", a: "Absolutely. Fast Passport Center serves all of Montgomery County including Takoma Park, Wheaton, Chevy Chase, Bethesda, Rockville, Kensington, Glenmont, Aspen Hill, Colesville, White Oak, Burtonsville, Olney, and all surrounding areas. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Silver Spring, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Silver Spring travelers use for international flights?", a: "Most Silver Spring residents fly internationally through Washington Dulles International Airport (IAD), approximately 30–40 minutes west via the Beltway. Reagan National (DCA) is 20–25 minutes south for domestic connections. Baltimore-Washington International (BWI) is also accessible. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can government employees get expedited passport services in Silver Spring?", a: "Yes. Fast Passport Center understands the unique travel needs of federal employees, diplomats, and government contractors. Whether you have an international assignment, conference, or diplomatic mission, we can expedite your passport processing to meet your government timeline." },
    { q: "Where is the closest passport acceptance facility to downtown Silver Spring?", a: "The Silver Spring Post Office at 8100 Fenton St is the primary downtown acceptance facility, walkable from the Silver Spring Metro station. The Wheaton Post Office at 11201 Amherst Ave serves western Silver Spring. The Bethesda Post Office at 6900 Wisconsin Ave serves southern Montgomery County. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Silver Spring residents should plan ahead, especially for government assignments and international conferences." },
  ],
  photoLocations: [
    { name: "Walgreens — Silver Spring", address: "8661 Colesville Rd, Silver Spring, MD 20910", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Silver Spring", address: "11160 Veirs Mill Rd, Silver Spring, MD 20902", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Bethesda", address: "4800 Hampden Ln, Bethesda, MD 20814", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Rockville", address: "1101 Wootton Pkwy, Rockville, MD 20852", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "MVA — Silver Spring", address: "2701 Wootton Pkwy, Rockville, MD 20850", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Silver Spring and central Montgomery County. REAL ID processing available.", featured: true },
    { name: "MVA — Gaithersburg", address: "15 Metropolitan Grove Rd, Gaithersburg, MD 20878", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Alternative for northern Montgomery County residents. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International (Washington DC)",
      distance: "30–40 minutes from Silver Spring",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Primary international departure airport for Silver Spring travelers. Direct long-haul flights to Europe, Asia, Africa, and South America. United Airlines hub with extensive international network.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "20–25 minutes from Silver Spring",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Convenient for domestic connections and short-haul international flights. Major business travel airport with Metro access.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "40–50 minutes from Silver Spring",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative for budget airlines and travelers with flexible routing. Southwest Airlines hub.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: false,
    },
  ],
};